import Vue from "vue";
import SearchBar from "@/components/ClinicsResult/SearchBar/SearchBar.vue";
import ClinicResultSubheader from "@/components/ClinicsResult/ClinicResultSubheader/ClinicResultSubheader.vue";
import ClinicResultHeader from "@/components/ClinicsResult/ClinicResultHeader/ClinicResultHeader.vue";
import NoResultArea from "@/components/ClinicsResult/NoResultArea/NoResultArea.vue";
import ServiceClinicCard from "@/components/ClinicsResult/ServiceClinicCard/ServiceClinicCard.vue";
import ServiceClinicCardSkeleton from "@/components/ClinicsResult/ServiceClinicCardSkeleton/ServiceClinicCardSkeleton.vue";
import ServiceAppointComponent from "@c/Home/Services/ServiceAppoint/ServiceAppoint.vue";
import SideModal from "@c/Util/SideModal/SideModal.vue";
import SearchError from "@/views/SearchError.vue";
import infiniteScroll from "vue-infinite-scroll";
import Service from "@/api/Services/Service";
import * as LoadingGif from "@/assets/gifs/loading.gif";
import * as LogoClinicarx from "@/assets/images/Logo_nova.png";
import Tenancy from "@/api/Services/Tenancy";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";
import ServiceDefaultName from "@/api/Services/ServiceDefaultName";
import MapService from "@/api/Services/MapService";
import NotFoundPage from "@/views/NotFound/NotFoundPage.vue";
import AppointmentService from "@/api/Services/Appointment";
import moment from "moment";

import { bus } from "@/main";
import { Component } from "vue-property-decorator";
import { ServiceModal } from "@/components/Home/Services/ServiceInterface";
import { AddressInterface, GeoCoordinatesInterface } from "@/api/Interfaces/MapInterface";
import { ServiceDefaultNameInterface } from "@/api/Interfaces/ServiceDefaultNameInterface";
import { ResponseInterface } from "@/api/Interfaces/ResponseInterface";
import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";
import { BIcon } from "bootstrap-vue"
import { mapGetters } from "vuex";
import { SelectTimeInterface } from "@/components/Home/Services/ServiceTimeSelect/SelectTimeInterface";
import SchrollBlock from "@/components/Util/SchrollBlock/SchrollBlock";
import ScrollBlock from "@/components/Util/SchrollBlock/SchrollBlock";

const ClinicsResultProps = Vue.extend({
  props: {
    address: {
      type: String,
      default: "",
    },
    zipCode: {
      type: String,
      default: null,
    },
    coordinates: {
      type: [Object as () => GeoCoordinatesInterface],
      default: null,
    },
    latitude: {
      type: Number,
      default: -25.42529645346497,
    },
    longitude: {
      type: Number,
      default: -49.240248152091446,
    },
    services: {
      type: Array,
      default: () => [],
    },
    selectedServiceDefaultName: {
      type: [Object as () => ServiceDefaultNameInterface],
      default: null,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    totalPages: {
      type: Number,
      default: -1,
    },
    isScrolling: {
      type: Boolean,
      default: false,
    },
    selectedSort: {
      type: String,
      default: "Ordenar por",
    },
    tenancyId: {
      type: String,
      default: "",
    },
    headerLogo: {
      type: String || LogoClinicarx,
    },
  },
  directives: {
    infiniteScroll,
  },
});

Component.registerHooks(["beforeRouteLeave", "metaInfo"]);

@Component<ClinicsResult>({
  name: "ClinicsResult",
  components: {
    BIcon,
    "search-bar": SearchBar,
    "clinic-result-header": ClinicResultHeader,
    "clinic-result-subheader": ClinicResultSubheader,
    "service-clinic-card": ServiceClinicCard,
    "service-appoint": ServiceAppointComponent,
    SideModal,
    SearchError,
    "no-result-area": NoResultArea,
    "not-found": NotFoundPage,
    "service-clinic-card-skeleton": ServiceClinicCardSkeleton
  },
  computed: mapGetters(["getDate", "getTime", "getAppointmentDate", "getSearchDate"]),

  watch: {
    getDate() {
      this.restartSearch();
    },
  }
})
export default class ClinicsResult extends ClinicsResultProps {
  cx_zipCode = window.sessionStorage.getItem("zipcode")
    ? JSON.parse(window.sessionStorage.getItem("zipcode") || "")
    : this.zipCode;
  cx_address = this.address || window.sessionStorage.getItem("address");
  cx_coordinates = window.sessionStorage.getItem("coordinates")
    ? JSON.parse(window.sessionStorage.getItem("coordinates") || "")
    : this.coordinates;
  cx_latitude = this.latitude;
  cx_longitude = this.longitude;
  cx_services = this.services;
  cx_pageSize = this.pageSize;
  cx_currentPage = this.currentPage;
  cx_totalPages = this.totalPages;
  cx_isScrolling = this.isScrolling;
  cx_selectedServiceDefaultName = this.selectedServiceDefaultName;
  cx_selectedSort = this.selectedSort;
  cx_header_logo = this.headerLogo || LogoClinicarx;
  cx_Service = new Service();
  cx_serviceModal: ServiceModal | null = null;
  cx_serviceModalEmpty: ServiceModal | null = null;
  cx_noResults = false;
  cx_tenancy_id = "";
  cx_dayHasHoursAvailable = false;
  cx_selectedDate = ""
  cx_logo_url = LogoClinicarx;
  cx_loading_gif = LoadingGif;
  cx_loadingMoreClinics = false;
  cx_loading = true;
  cx_searchLoading = false;
  cx_loadingServiceDefaultName = false;
  cx_servicesRequestInProgress = false;
  cx_servicesRequestVersion = 0;
  cx_locationBlocked = false;
  showUnavailablePage = false;

  cx_isConsultingGeoCoordinates!: boolean;
  cx_isConsultingGeoCoordinatesCheckBox!: boolean;
  cx_allowAccessMyLocation!: boolean;

  clinic_ids = [];

  getDate!: string;
  getClinicId!: string;
  getTime!: SelectTimeInterface;
  getAppointmentDate!: string;
  getSearchDate!: string;
  cx_times = {};

  cx_zipCodeCheckBox!: boolean;
  cx_zipCodeIsVisible!: boolean;
  cx_isConsultingZipCode!: boolean;
  cx_isInvalidCep!: boolean;
  cx_checkboxZipCodeIsActive!: string;
  cx_directSearch!: boolean;

  cx_ServiceDefaultName!: ServiceDefaultName;
  cx_serviceCategories!: Array<ServiceDefaultName>;
  cx_buttonActive!: string;
  cx_prerender!: boolean;
  cx_notFound = false;
  cx_showNotFoundPage = false;
  cx_noNearbyClinics = false;
  /**
   * -----------------------------------------
   * EVENTS
   * -----------------------------------------
   */

  beforeMount(): void {
    this.cx_loading = true;
    this.cx_serviceModalEmpty = {
      selectedService: null,
      clinic: null,
      modalOpened: false,
    };
    this.cx_isConsultingGeoCoordinates = false;
    this.cx_isConsultingGeoCoordinatesCheckBox = false;
    this.cx_allowAccessMyLocation = false;
    this.cx_prerender = !!this.$route.query.prerender && this.$route.query.prerender == "1";

    this.cx_serviceModal = this.cx_serviceModalEmpty;
    this.cx_notFound = false;
    this.showUnavailablePage = false;
    this.cx_dayHasHoursAvailable = false;
    this.cx_selectedDate = "";
  }

  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  }

  mounted() {
    GoogleAnalyticsEvents.loadResultPage();
    window.addEventListener("scroll", this.onScroll);
    if (!this.cx_coordinates && !this.cx_prerender) {
      this.openConfirmMyLocationModal();
    } else if (!this.cx_selectedServiceDefaultName) {
      this.getServiceByServiceName();
    }
    this.getTenancy();
  }

  metaInfo() {
    return {
      title: `${this.cx_selectedServiceDefaultName?.search_name || ""} | Clinicarx `,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: `${this.cx_selectedServiceDefaultName?.meta_description || ""} `,
        },
      ],
    };
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.cx_serviceModal?.modalOpened) {
      this.clearServiceModal();
      next(false);
    } else next();
    this.handleScrollBlock(false);
  }

  setAddress(address: AddressInterface): void {
    this.cx_address = address.street
      ? `${address.street}, ${address.city}/${address.state}`
      : `${address.city}/${address.state}`;
  }
  consultZipCode(): void {
    this.cx_isConsultingZipCode = true;

    MapService.getLocationByZipCode(this.cx_zipCode)
      .then((response) => {
        const address: AddressInterface = response as AddressInterface;
        if (address) {
          this.cx_isInvalidCep = false;
          this.setAddress(address);

          MapService.getGeoCoordinatesByAddress(address).then((response) => {
            this.cx_coordinates = response as GeoCoordinatesInterface;
          });
        } else {
          this.cx_isInvalidCep = true;
          this.cx_coordinates = {} as GeoCoordinatesInterface;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => (this.cx_isConsultingZipCode = false));
  }

  noAddressFound() {
    this.cx_notFound = true;
    this.setSearchLoading(false);
  }

  activateMyLocation(): void {
    this.cx_zipCode = this.cx_zipCode === null || this.cx_zipCode.length > 0 ? "" : null;

    if (!navigator.geolocation) {
      alert("O seu navegador não suporta Geolocalização");
      return;
    }
    this.cx_isConsultingGeoCoordinates = true;
    navigator.geolocation.getCurrentPosition(
      (response) => {
        this.cx_coordinates = {} as GeoCoordinatesInterface;
        this.cx_coordinates.latitude = response.coords.latitude;
        this.cx_coordinates.longitude = response.coords.longitude;
        this.restartSearch();
        MapService.getAddressByGeoCoordinates(response.coords.latitude, response.coords.longitude)
          .then((response) => {
            this.cx_notFound = false;
            const address: AddressInterface = response as AddressInterface;
            if (address) {
              this.setAddress(address);
            } else {
              throw new Error(address);
            }
          })
          .catch((error) => {
            this.setSearchLoading(false);
            console.error(error);
          })
          .finally(() => (this.cx_isConsultingGeoCoordinates = false));
      },

      (_error) => {
        this.cx_isConsultingGeoCoordinates = false;
        this.cx_allowAccessMyLocation = false;
        this.cx_locationBlocked = true;
        this.setSearchLoading(false);
      }
    );
  }

  getNavigatorGeolocationState(): void {
    navigator.permissions && navigator.permissions.query({name: 'geolocation'})
    .then((PermissionStatus) => {
        if (PermissionStatus.state === 'denied') {
          this.cx_allowAccessMyLocation = false;
          this.cx_locationBlocked = true;
          bus.$emit("showLoading", false);
          this.setSearchLoading(false);
        } else {
          this.activateMyLocation();
        }
    })
  }

  openConfirmMyLocationModal(): void {
    this.$bvModal.show("confirm-my-location-modal");
  }

  closeConfirmMyLocationModal(allowAccess: boolean): void {
    this.$bvModal.hide("confirm-my-location-modal");
    this.getServiceByServiceName();

    if (allowAccess) {
      GoogleAnalyticsEvents.allowLocation();
      this.cx_allowAccessMyLocation = true;
      this.getNavigatorGeolocationState();
    } else {
      GoogleAnalyticsEvents.dontAllowLocation();
      this.cx_isConsultingGeoCoordinatesCheckBox = false;

      if (this.cx_directSearch) {
        this.cx_directSearch = false;
      }
      this.cx_notFound = true;
      this.setSearchLoading(false);
    }
    this.cx_loading = true;
  }

  confirmMyLocation(): void {
    this.closeConfirmMyLocationModal(true);
  }

  getServiceByServiceName(): void {
    this.cx_loadingServiceDefaultName = true;
    this.setSearchLoading(true);

    ServiceDefaultName.getByServiceName(this.$route.params.serviceName).then((response) => {
      this.cx_loadingServiceDefaultName = false;
      const responseData = response.data as ResponseInterface;

      if (responseData.data[0]) {
        this.showUnavailablePage = false;
        this.cx_selectedServiceDefaultName = responseData.data[0];
        this.$router.replace({
          params: {
            serviceName: this.cx_selectedServiceDefaultName.url_parameter,
          },
        });
        this.getServices();
      } else {
        this.cx_showNotFoundPage = true;
        this.setSearchLoading(false);
      }
    }).catch(() => {
      this.cx_loadingServiceDefaultName = false;
      this.showUnavailablePage = true;
      this.setSearchLoading(false);
    });
  }

  changeServiceDefaultName(ServiceDefaultName: any): void {
    this.cx_selectedServiceDefaultName = ServiceDefaultName;
    sessionStorage.setItem("service", JSON.stringify(this.cx_selectedServiceDefaultName));
  }

  setSearchLoading(isLoading: boolean): void {
    this.cx_loading = isLoading;
    this.cx_searchLoading = isLoading;

    if (isLoading) {
      this.cx_noNearbyClinics = false;
      this.cx_notFound = false;
      this.cx_showNotFoundPage = false;
      this.cx_locationBlocked = false;
      this.showUnavailablePage = false;
    }
  }

  getServices(): void {
    if (this.cx_servicesRequestInProgress) return;

    if (this.cx_currentPage >= this.cx_totalPages && this.cx_totalPages != -1) {
      this.setSearchLoading(false);
      return;
    }

    if (!this.cx_selectedServiceDefaultName) {
      this.setSearchLoading(this.cx_loadingServiceDefaultName);
      return;
    }

    if (!this.cx_coordinates && !this.cx_prerender) {
      const isWaitingForCoordinates = this.cx_allowAccessMyLocation || this.cx_isConsultingGeoCoordinates;
      this.setSearchLoading(isWaitingForCoordinates);
      return;
    }

    this.cx_locationBlocked = false;
    let sortBy = this.cx_selectedSort;
    if (this.cx_selectedSort === "Ordenar por") sortBy = "distance ASC";

    const requestVersion = this.cx_servicesRequestVersion;
    const requestedPage = this.cx_currentPage + 1;

    this.cx_services = (requestedPage === 1) ? [] : this.cx_services;
    this.cx_currentPage = requestedPage;
    const filters = {
      min_price: 5,
      near_by: this.cx_prerender
        ? null
        : `${this.cx_coordinates.latitude},${this.cx_coordinates.longitude},${sortBy}`,
      service_default_name_id: this.cx_selectedServiceDefaultName.id,
      tenancy_id: this.tenancyId,
    };
    const includes = ["clinic.address.city.state", "clinic.phones", "service_default_name"];

    if (requestedPage == 1) {
      this.setSearchLoading(true);
    } else {
      this.cx_loadingMoreClinics = true;
    }
    this.cx_servicesRequestInProgress = true;

    this.cx_Service
      .index(requestedPage, this.cx_pageSize, filters, includes, sortBy)
      .then((response) => {
        if (requestVersion !== this.cx_servicesRequestVersion) return;

        this.showUnavailablePage = false;
        this.cx_notFound = false;
        const responseData = response.data as ResponseInterface;
        const data = responseData.data;
        if ((!data.data || data.data.length <= 0) && requestedPage == 1) {
          this.cx_noNearbyClinics = true;
          this.cx_loadingMoreClinics = false;
          this.cx_servicesRequestInProgress = false;
          this.setSearchLoading(false);

          GoogleAnalyticsEvents.serviceWithoutClinic();
        } else {
          this.cx_noNearbyClinics = false;
          this.cx_totalPages = data.last_page;
          const clinicIds = data.data.map((service: any) => service.clinic.id);
          this.clinic_ids = clinicIds;
          this.getHoursAvailableClinics(clinicIds, requestVersion).then(() => {
            if (requestVersion !== this.cx_servicesRequestVersion) return;

            this.cx_services = requestedPage === 1
              ? data.data
              : this.cx_services.concat(data.data);
          }).catch(e => {
            throw e;
          });
        }
      })
      .catch((error) => {
        if (requestVersion !== this.cx_servicesRequestVersion) return;

        this.cx_currentPage = Math.max(0, requestedPage - 1);
        this.showUnavailablePage = true;
        this.cx_loadingMoreClinics = false;
        this.cx_servicesRequestInProgress = false;
        this.setSearchLoading(false);
      });
  }

  getHoursAvailableClinics(clinicIds: Array<string>, requestVersion: number): Promise<void> {
    const date = new Date();
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const currentDate = `${ year }-${ month }-${ day }`;
    const formattedSelectedDate = moment(this.getDate || currentDate).format('YYYY-MM-DD');

    return AppointmentService.getClinicGroupAvailableHours(formattedSelectedDate, clinicIds).then((response: any) => {
      if (requestVersion !== this.cx_servicesRequestVersion) return;

      Object.keys(response.data.data).filter((clinicId) => {
        this.showUnavailablePage = false;
        response.data.data[clinicId] = response.data.data[clinicId].filter((hour: any, index: any) => {
          hour.id = index;
          return hour.available;
        });

        if (response.data.data[clinicId].length === 0) {
          response.data.data[clinicId] = false;
        }
      });
      this.cx_times = {
        ...this.cx_times,
        ...response.data.data,
      }
    }).catch((error) => {
      if (requestVersion !== this.cx_servicesRequestVersion) return;

      this.showUnavailablePage = true;
    }).finally(() => {
      if (requestVersion !== this.cx_servicesRequestVersion) return;

      this.cx_loadingMoreClinics = false;
      this.cx_servicesRequestInProgress = false;
      this.setSearchLoading(false);
    });
  }

  changeSearchSort(sortBy: any): void {
    this.cx_selectedSort = sortBy;
    this.restartSearch();
  }

  restartSearch(): void {
    this.cx_servicesRequestVersion++;
    this.cx_servicesRequestInProgress = false;
    this.cx_loadingMoreClinics = false;
    this.setSearchLoading(true);
    this.cx_currentPage = 0;
    this.cx_services = [];
    this.cx_totalPages = -1;
    this.cx_times = {};
    this.cx_noNearbyClinics = false;
    this.showUnavailablePage = false;
    this.getServices();
  }

  getSlugId() {
    return this.$route.name == "SearchServicesTenancy" ? this.$route.params.slugId : "";
  }

  getTenancy() {
    if (!this.getSlugId()) return false;

    Tenancy.getTenancy(this.getSlugId()).then((response: any) => {
      const responseData = response as ResponseInterface;
      if (!responseData) {
        this.$router.push({ name: "Home" });
      } else {
        this.cx_tenancy_id = responseData.data.id;
      }
    });
  }

  changeSearch(
    coordinates: GeoCoordinatesInterface,
    serviceDefaultName: ServiceDefaultNameInterface,
    address: string
  ): void {
    this.cx_selectedServiceDefaultName = serviceDefaultName;
    this.cx_coordinates = coordinates;
    this.cx_address = address;

    if (!this.$route.params.serviceName) {
      this.$router.replace({
        params: {
          serviceName: this.cx_selectedServiceDefaultName.url_parameter,
        },
      });
    }

    this.changeSearchSort("Ordenar por");
    sessionStorage.setItem("coordinates", JSON.stringify(this.cx_coordinates));
    sessionStorage.setItem("address", this.cx_address);
  }

  onScroll(): void {
    if (this.cx_isScrolling != null) this.cx_isScrolling = window.scrollY > 0;

    const bottomOfWindow = window.innerHeight + window.scrollY >= document.body.offsetHeight;

    if (bottomOfWindow && !this.cx_loadingMoreClinics && !this.cx_loading && this.cx_currentPage < this.cx_totalPages) {
      this.getServices();
    }
  }

  scrollToTop(): void {
    window.scrollTo(0, 0);
  }

  clearServiceModal(): void {
    this.cx_serviceModal = this.cx_serviceModalEmpty;
    this.$store.commit("setCpf", "");
    this.$store.commit("setPatientData", null);
  }

  closeModal(event: Event): void {
    this.handleScrollBlock(false);
    this.restartSearch();
    if (!event) this.clearServiceModal();
  }

  openModalHandler(service: ServiceInterface): void {
    GoogleAnalyticsEvents.scheduleAppointment();
    this.$store.commit("setService", service);
    this.$store.commit("setClinicId", service.clinic_id);
    this.cx_serviceModal = {
      selectedService: service,
      clinic: null,
      modalOpened: true,
    };
  }

  openScheduleModal(service: ServiceInterface, hoursAvailable: boolean ): void {
    this.handleScrollBlock(true)
    this.cx_dayHasHoursAvailable = hoursAvailable;
    this.openModalHandler(service);
    this.$store.commit("setPatient", {});
  }

handleScrollBlock(shouldLock: boolean): void {
  const scrollLock = new ScrollBlock();
  shouldLock ? scrollLock.lock() : scrollLock.unlock();
}
}
